import { Button, Form, Select, Typography, Row, Col, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useContext, useState } from "react";
import TabsHeader from "../../../../Components/Shared/TabsHeader";
import { useParams } from "react-router-dom";
import { CompanyFinepContext } from "../../../../Contexts/CompanyFinepContext";
import { useAuth } from "../../../../Hooks/useAuth";
import AddressFinepPartial from "../../../../Components/CompanyFinep/AddressFinepPartial";
import { ValidateAddressFinep } from "../../../../API/AddressFinepAPI";

const { Title, Text } = Typography;
const { Option } = Select;

const AddressFinepTab = () => {
    const { companyId, registerId } = useParams();
    const user = useAuth();
    const [hasCorrespondenceAddress, setHasCorrespondenceAddress] = useState("1");
    const [hasBillingAddress, setHasBillingAddress] = useState("1");
    const [loading, setLoading] = useState(false);
    const [validateField, setValidateField] = useState(false);
    const { changeTab, handleValidateTab, handleInvalidateTab } = useContext(CompanyFinepContext);
    async function handleValidate(isValid: boolean) {
        setLoading(true);
        setValidateField(isValid);
        await ValidateAddressFinep({
            companyFINEPId: companyId ?? "",
            isContentValid: isValid,
            userEmail: user.userEmail
        }).then(() => {
            if (isValid)
                handleValidateTab(1, 3);
            else
                handleInvalidateTab(1, 3);
        }).catch(() => setLoading(false));
        setLoading(false);
    }
    return (
        <Spin spinning={loading}>
            <TabsHeader
                canValidate={true}
                valueSelected={validateField}
                changeValidate={handleValidate}
                registerId={registerId}
                cardName=""
                tabName=""
            />
            <div className="mt-4">
                <Title level={4} style={{ color: '#000085', fontSize: '22px', fontWeight: 'normal' }}>Cadastro Pessoa Jurídica - Proponente ou Executora</Title>
                <Text style={{ color: '#777777', fontSize: '18px', fontWeight: 'normal' }}>Informações primárias da empresa</Text>
                <AddressFinepPartial type='matrix' setValidateField={setValidateField} />
                <Form.Item label="Endereço de correspondência é o mesmo da sede?" className="mt-4">
                    <Select
                        style={{ width: 200 }}
                        value={hasCorrespondenceAddress}
                        onChange={(value) => setHasCorrespondenceAddress(value)}
                    >
                        <Option value="1">Sim</Option>
                        <Option value="0">Não</Option>
                    </Select>
                </Form.Item>
                <AddressFinepPartial
                    setValidateField={setValidateField}
                    type='correspondence'
                    valueInForm={hasCorrespondenceAddress}
                    setHasValueInForm={setHasCorrespondenceAddress}
                />
                <Form.Item label="Endereço de cobrança é o mesmo da sede?" className="mt-4">
                    <Select
                        style={{ width: 200 }}
                        value={hasBillingAddress}
                        onChange={(value) => setHasBillingAddress(value)}
                    >
                        <Option value="1">Sim</Option>
                        <Option value="0">Não</Option>
                    </Select>
                </Form.Item>
                <AddressFinepPartial
                    setValidateField={setValidateField}
                    type='branch'
                    valueInForm={hasBillingAddress}
                    setHasValueInForm={setHasBillingAddress}
                />
                <Row justify="end" gutter={16} className="mt-4">
                    <Col>
                        <Button type="default" onClick={() => changeTab(0)}>Voltar</Button>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={() => changeTab(2)}><PlusOutlined/> Próxima Etapa</Button>
                    </Col>
                </Row>
            </div>
        </Spin>
    )
};
export default AddressFinepTab;